import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20dark%20moody%20healthcare%20environment%2C%20nurse%20in%20dark%20navy%20scrubs%20walking%20through%20a%20dimly%20lit%20modern%20hospital%20corridor%20at%20dusk%2C%20deep%20shadow%20tones%2C%20cool%20dark%20teal%20and%20charcoal%20color%20palette%2C%20cinematic%20low-key%20lighting%20with%20subtle%20blue-grey%20ambient%20glow%2C%20sleek%20contemporary%20medical%20facility%20interior%2C%20professional%20clinical%20atmosphere%2C%20high%20contrast%20photorealistic%20photography%2C%20dark%20background%20with%20minimal%20highlights&width=1600&height=900&seq=hero-bh-dark-003&orientation=landscape"
          alt="Behavioral health nursing professional"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(13,32,32,0.95), rgba(26,58,58,0.9), rgba(13,32,32,0.8))' }} />
      </div>

      {/* Decorative diagonal stripe */}
      <div className="absolute top-0 right-0 w-1/3 h-full overflow-hidden pointer-events-none">
        <div
          className="absolute top-0 right-0 w-full h-full opacity-10"
          style={{
            background: 'repeating-linear-gradient(135deg, #c8a84b 0px, #c8a84b 2px, transparent 2px, transparent 24px)',
          }}
        />
      </div>

      {/* Gold accent bar */}
      <div className="absolute top-0 left-0 w-1 h-full bg-[#c8a84b]" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-8 md:px-14 pt-32 lg:pt-36 flex flex-col lg:flex-row items-center gap-16">
        {/* Left: Main copy */}
        <div className="flex-1 text-left">
          <div className="flex items-center gap-3 mb-8">
            <div className="h-px w-10 bg-[#c8a84b]" />
            <span
              className="text-[#c8a84b] text-xs font-bold tracking-[0.3em] uppercase"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Your Trusted Staffing Partner
            </span>
          </div>

          <h1
            className="text-5xl md:text-7xl font-extrabold text-white leading-[1.05] mb-6"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            The Right People.
            <br />
            <em className="not-italic text-[#c8a84b]">Right Now.</em>
          </h1>

          <p
            className="text-white text-lg md:text-xl leading-relaxed mb-10 max-w-lg"
            style={{ fontFamily: "'Inter', sans-serif", opacity: 0.7 }}
          >
            We bring talented people to the companies that need them.
            Fast, reliable, and hassle free.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4">
            <Link
              to="/contact"
              className="px-8 py-4 rounded-md bg-[#c8a84b] text-white font-bold text-sm tracking-wide hover:bg-[#b8943b] transition-all duration-200 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Contact Us Today
            </Link>
            <Link
              to="/services"
              className="px-8 py-4 rounded-md border text-white font-semibold text-sm tracking-wide transition-all duration-200 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif", borderColor: 'rgba(255,255,255,0.3)' }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              Our Services
            </Link>
          </div>
        </div>

        {/* Right: Rack card style info panel */}
        <div className="lg:w-80 w-full backdrop-blur-sm rounded-lg p-8"
          style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)' }}
        >
          <h3
            className="text-white font-bold text-base mb-6 pb-4"
            style={{ fontFamily: "'Montserrat', sans-serif", borderBottom: '1px solid rgba(255,255,255,0.15)' }}
          >
            Why Continuous Staffing?
          </h3>
          <ul className="space-y-4">
            {[
              'Fast Turnaround',
              'Pre-Screened Candidates',
              'Flexible Assignments',
              'Hands-Off Administration',
              'Ongoing Support',
              'Dedicated Account Manager',
            ].map((item) => (
              <li key={item} className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-[#c8a84b] text-base font-bold" />
                </div>
                <span
                  className="text-white text-sm font-medium"
                  style={{ fontFamily: "'Inter', sans-serif", opacity: 0.85 }}
                >
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Promise bar */}
      <div className="relative z-10 w-full mt-16"
        style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}
      >
        <div className="max-w-6xl mx-auto px-8 md:px-14 py-8 grid grid-cols-3 gap-6">
          {[
            { icon: 'ri-timer-flash-line', label: 'Fast Placement' },
            { icon: 'ri-shield-check-line', label: 'Pre-Screened Candidates' },
            { icon: 'ri-customer-service-2-line', label: 'Dedicated Support' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-2 text-center">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-[#c8a84b] text-2xl`} />
              </div>
              <div
                className="text-sm text-white tracking-wide font-medium"
                style={{ fontFamily: "'Inter', sans-serif", opacity: 0.7 }}
              >
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}